import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[mtgStopPropagation]'
})
export class StopPropagationDirective {
  @HostListener('click', ['$event'])
  onClick($event) {
    $event.stopPropagation();
  }
}
